import * as React from 'react'

interface Props {
    level: 'info' | 'warning'
    children: React.ReactNode
    compact: boolean
    additionalClasses?: string
    title?: string
}

export class Alert extends React.Component<Props> {
    static defaultProps = {
        compact: false,
    }
    public render = () => (
        <div
            className={
                'tw-m-0 ' +
                this.alertClasses(this.props.compact, this.props.level) +
                (this.props.additionalClasses ? ' ' + this.props.additionalClasses : '')
            }
            title={this.props.title}
        >
            {this.props.children}
        </div>
    )

    alertClasses = (compact: boolean, level): string => (compact ? 'compact-alert compact-alert-' + level : 'alert alert-' + level)
}
